// Cove tier (T1 flagship … T5). Read-only in DomainHQ.
const STYLES: Record<string, string> = {
  T1: 'bg-violet-100 text-violet-800 ring-violet-200',
  T2: 'bg-blue-100 text-blue-800 ring-blue-200',
  T3: 'bg-teal-100 text-teal-800 ring-teal-200',
  T4: 'bg-slate-100 text-slate-700 ring-slate-200',
  T5: 'bg-slate-100 text-slate-500 ring-slate-200',
};

export default function TierBadge({ tier }: { tier: string }) {
  return (
    <span className={`inline-flex items-center rounded px-1.5 py-0.5 text-xs font-semibold ring-1 ring-inset ${STYLES[tier.toUpperCase()] ?? 'bg-slate-100 text-slate-700 ring-slate-200'}`}
      title="Tier from Cove (read-only)">
      {tier}
    </span>
  );
}
